import { publicApiAuthScopeSchema } from "@redotech/redo-model/public-api-auth";
import * as z from "zod";
import { apiTokenSchema } from "./types";

export const updateApiToken = {
  name: "updateApiToken" as const,
  input: z.object({
    id: z.bigint(),
    name: z.string().min(1).optional(),
    scopes: z.array(publicApiAuthScopeSchema).optional(),
  }),
  output: z.object({ token: apiTokenSchema }),
};
